/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Order } from '../../core/_models'

type Props = {
  order: Order
}

const OrderInfoCell: FC<Props> = ({ order }) =>{
  return(
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {order.reseller?.profile_image_url ? (
            <div className='symbol-label'>
              <img src={`${order.reseller?.profile_image_url}`} alt={order.reseller.reseller_name} className='w-100' />
            </div>
          ) : (
            <div
              className={clsx(
                'symbol-label fs-3',
                `bg-light-${order.reseller.reseller_name}`,
                `text-${order.reseller.reseller_name}`
              )}
            >
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {order.reseller.reseller_name}
        </a>
        {/* <span>{order.reseller.reseller_name}</span> */}
      </div>
    </div>
  )
}

export { OrderInfoCell }
